export enum ColorPickerType {
	Circle = 1,
	Sketch = 2
}
